<svg
  width="19"
  height="14"
  viewBox="0 0 19 14"
  fill="none"
  class={$$restProps.class}
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M1.56716 14C1.11443 14 0.74005 13.852 0.44403 13.556C0.14801 13.26 0 12.8856 0 12.4328V1.56716C0 1.11443 0.14801 0.74005 0.44403 0.44403C0.74005 0.14801 1.11443 0 1.56716 0H6.45149L8.54104 2.08955H16.6119C17.0647 2.08955 17.4391 2.23756 17.7351 2.53358C18.0311 2.8296 18.1791 3.20398 18.1791 3.65672V12.4328C18.1791 12.8856 18.0311 13.26 17.7351 13.556C17.4391 13.852 17.0647 14 16.6119 14H1.56716ZM1.56716 13.2687H16.6119C16.8557 13.2687 17.056 13.1903 17.2127 13.0336C17.3694 12.8769 17.4478 12.6766 17.4478 12.4328V3.65672C17.4478 3.41294 17.3694 3.21269 17.2127 3.05597C17.056 2.89925 16.8557 2.8209 16.6119 2.8209H8.25373L6.16418 0.731343H1.56716C1.32338 0.731343 1.12313 0.809702 0.966418 0.966418C0.809701 1.12313 0.731343 1.32338 0.731343 1.56716V12.4328C0.731343 12.6766 0.809701 12.8769 0.966418 13.0336C1.12313 13.1903 1.32338 13.2687 1.56716 13.2687Z"
    fill="#1C1C20"
  />
</svg>
